import PropTypes from 'prop-types'
import { Box } from '@material-ui/core'
import { useStyles } from './styles'
import React, { useMemo } from 'react'
import { useRef, useState } from 'react'
import { ListComponent } from './list-component'
import { getMainListItems } from './constants'
import Loader from '../../root/components/common/loader'
import classNames from 'classnames'
import { CustomSwitch } from '../../root/components/common/switch'
import { HeatmapType } from './heatmap-type'
import ArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import ArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import { PlusIcon, FilterIcon, EyeIcon, EyeOffIcon } from 'lucide-react'

export const WebButtonsGroup = ({
    onAddDevices,
    handleToggleMarkerDrag,
    permissions,
    filterDevices,
    devicesFilters,
    locale,
    isDraggable,
    isLoadingHeatmap,
    toggleHeatmap,
    isHeatmapVisible,
    heatmapFilters,
    applyHeatmapFilter,
    totalFiltersApplied,
    totalHeatmapApplied,
    resetHeatmapFilters
}) => {
    const classes = useStyles()
    const filterDeviceBtnRef = useRef([])
    const heatMapTypeBtnRef = useRef([])
    const heatmapRef = useRef(null)
    const [isHeatmapDropdownActive, setIsHeatmapDropdownActive] = useState(
        false
    )
    const [
        isHeatmapTypeDropdownActive,
        setIsHeatmapTypeDropdownActive
    ] = useState(false)

    const hasFiltersChanged = useMemo(() => {
        return (
            (devicesFilters && devicesFilters.length > 0) ||
            totalHeatmapApplied > 0
        )
    }, [devicesFilters, totalHeatmapApplied])

    return (
        <Box className={classes.container}>
            <Box
                className={classNames(classes.wrapper, {
                    [classes.disableWrapper]: !permissions
                })}
                onClick={permissions ? onAddDevices : null}
            >
                <div className={classes.buttonBoxSection}>
                    <PlusIcon size={20} color="grey" />
                </div>
                <div className={classes.buttonBoxSection}>
                    {locale.locations.floorPlanBtns.add}
                </div>
            </Box>
            <Box
                ref={filterDeviceBtnRef}
                className={classes.wrapper}
                onClick={() => setIsHeatmapDropdownActive(true)}
            >
                <div className={classes.buttonBoxSection}>
                    <FilterIcon size={20} color="grey" />
                </div>
                <div
                    className={classNames(
                        classes.buttonBoxSection,

                        {
                            [classes.appliedFiltersLabel]: hasFiltersChanged
                        }
                    )}
                >
                    <div className={classes.totalNumberFiltersWrapper}>
                        {locale.locations.floorPlanBtns.allFilters}
                        <div className={classes.totalNumberFilters}>
                            {totalFiltersApplied + totalHeatmapApplied}
                        </div>
                    </div>
                </div>
                <ListComponent
                    ref={filterDeviceBtnRef}
                    listItems={getMainListItems(locale)}
                    toggleDropDown={isHeatmapDropdownActive}
                    setToggleDropDown={setIsHeatmapDropdownActive}
                    filterDevices={filterDevices}
                    heatmapFilters={heatmapFilters}
                    applyHeatmapFilter={applyHeatmapFilter}
                    hasFiltersChanged={hasFiltersChanged}
                    resetHeatmapFilters={resetHeatmapFilters}
                    locale={locale}
                />
            </Box>
            <Box ref={heatmapRef} className={classes.wrapper}>
                {isLoadingHeatmap ? (
                    <div className={classes.buttonBoxSection}>
                        <Loader />
                    </div>
                ) : (
                    <>
                        <div className={classes.buttonBoxSection}>
                            {isHeatmapVisible ? (
                                <EyeOffIcon
                                    size={20}
                                    color="grey"
                                    onClick={toggleHeatmap}
                                />
                            ) : (
                                <EyeIcon
                                    size={20}
                                    color="grey"
                                    onClick={toggleHeatmap}
                                />
                            )}
                            {/* <Icon
                                path={
                                    isHeatmapVisible
                                        ? mdiEyeOffOutline
                                        : mdiEyeOutline
                                }
                                size={0.9}
                                color="grey"
                                onClick={toggleHeatmap}
                            /> */}
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}
                            ref={heatMapTypeBtnRef}
                        >
                            <div
                                className={classes.buttonBoxSection}
                                onClick={() =>
                                    isHeatmapVisible
                                        ? setIsHeatmapTypeDropdownActive(
                                              !isHeatmapTypeDropdownActive
                                          )
                                        : null
                                }
                            >
                                {locale.locations.heatmap}
                                {isHeatmapVisible &&
                                    (isHeatmapTypeDropdownActive ? (
                                        <ArrowUpIcon />
                                    ) : (
                                        <ArrowDownIcon />
                                    ))}
                            </div>
                        </div>
                        <HeatmapType
                            ref={heatMapTypeBtnRef}
                            locale={locale}
                            heatmapFilters={heatmapFilters}
                            toggleDropDown={isHeatmapTypeDropdownActive}
                            setToggleDropDown={setIsHeatmapTypeDropdownActive}
                            applyHeatmapFilter={applyHeatmapFilter}
                        />
                    </>
                )}
            </Box>
            <Box
                className={classNames(classes.wrapper, {
                    [classes.disableWrapper]: !permissions
                })}
                onClick={permissions ? handleToggleMarkerDrag : null}
            >
                <div className={classes.buttonBoxSection}>
                    <CustomSwitch
                        lockIcons
                        isChecked={isDraggable}
                        disabled={!permissions}
                    />
                </div>
                <div className={classes.buttonBoxSection}>
                    {isDraggable
                        ? locale.locations.lockMarkers
                        : locale.locations.unlockMarkers}
                </div>
            </Box>
        </Box>
    )
}

WebButtonsGroup.propTypes = {
    onDelete: PropTypes.func.isRequired,
    onAddDevices: PropTypes.func.isRequired,
    handleToggleMarkerDrag: PropTypes.func.isRequired,
    permissions: PropTypes.bool.isRequired
}
